import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';


// ------------------ list PO-------
const getAllPO = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.po.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllPOQuery = (filter) => {
    return useQuery(['POlist', filter], () => getAllPO(filter));

};
// ------------------ Add PO-------
const addPO = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.po.add, payload);
};
const AddPOMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addPO, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('POlist');
            toastMessage('success', 'PO Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ list non-inventory PO-------
const getNonInventoryPO = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.po.nonInventoryList + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetNonInventoryPOQuery = (filter) => {
    return useQuery(['nonInventoryPOlist', filter], () => getNonInventoryPO(filter));
};

export { GetAllPOQuery, AddPOMutation, GetNonInventoryPOQuery };
